import {
  useWSModalCustom,
  WSActions,
  WSAlert,
  WSCopyText,
  WSList,
  WSModal,
  WSModalCustomProps,
  WSText
} from "@wingspanhq/fe-component-library";
import { ApiKeyWithSecret } from "@wingspanhq/wingspan-api-sdk";
import React from "react";

type Props = {
  apiKey: ApiKeyWithSecret;
} & WSModalCustomProps<void>;

const ModalApiKeySecret: React.FC<Props> = props => (
  <WSModal
    size="S"
    title="Copy your API key"
    onClose={() => props.onClose()}
    blockClose
  >
    <WSList gap="L">
      <WSText.Paragraph>
        This is the only time the key <b>{props.apiKey.name}</b> will be shown.
        Copy it now and store it somewhere safe.
      </WSText.Paragraph>

      <WSCopyText
        data={props.apiKey.secret}
        shareTitle="API key"
        isURL={false}
      />

      <WSAlert theme="warning" icon="alert-circle">
        You won't be able to see this key again. If you lose it, rotate the key
        to generate a new one.
      </WSAlert>

      <WSActions
        alignment="fill"
        buttons={[{ label: "Done", onClick: () => props.onClose() }]}
      />
    </WSList>
  </WSModal>
);

export const useModalApiKeySecret = () => useWSModalCustom(ModalApiKeySecret);
